module.exports = __webpack_public_path__ + "static/media/cross.f59ce89e.svg";